import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "./Header.jsx";
import Footer from "./footer.jsx";
import "../../styles/landing-page.css";

const AboutSulhafaCare = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <div className={`about-care-container ${i18n.dir() === 'rtl' ? 'rtl' : 'ltr'}`}>
        <div className="about-care-content">
          <div className="about-care-text">
            <h1 className="about-care-title">{t('aboutCare.header.title')}</h1>
            <p className="about-care-desc">
              {t('aboutCare.header.intro')}
              <br /><br />
              <strong>{t('aboutCare.header.solution')}</strong>
              <br /><br />
              {t('aboutCare.header.description')}
            </p>
          </div>
          <div className="about-care-image">
            <img
              src="/images/Sulhafa-Vet.png"
              alt={t('aboutCare.alt.mascot')}
              style={{ transform: i18n.dir() === 'rtl' ? 'scaleX(-1)' : 'none' }}
            />
          </div>
        </div>
        <div className="about-care-offer-section">
          <h2 className="about-care-offer-title">{t('aboutCare.features.title')}</h2>
          <p className="about-care-offer-desc">
            {t('aboutCare.features.subtitle')}
          </p>
          <div className="about-care-offer-cards">
            {/* Card 1 */}
            <div className="about-care-offer-card" style={{ direction: i18n.dir() }}>
              <div
                className="about-care-offer-icon"
                style={{ background: "#19c37d" }}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="12" fill="#19c37d" />
                  <path
                    d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                    stroke="#fff"
                    strokeWidth="2"
                  />
                  <circle cx="9" cy="7" r="4" stroke="#fff" strokeWidth="2" />
                  <path
                    d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                    stroke="#fff"
                    strokeWidth="2"
                  />
                </svg>
              </div>
              <h3 className="about-care-offer-card-title">
                {t('aboutCare.features.directAccess.title')}
              </h3>
              <p className="about-care-offer-card-desc">
                {t('aboutCare.features.directAccess.description')}
              </p>
            </div>
            {/* Card 2 */}
            <div className="about-care-offer-card" style={{ direction: i18n.dir() }}>
              <div
                className="about-care-offer-icon"
                style={{ background: "#19c37d" }}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="12" fill="#19c37d" />
                  <path
                    d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <circle cx="12" cy="17" r="1" fill="#fff" />
                  <rect x="8" y="4" width="8" height="4" rx="2" fill="#fff" />
                </svg>
              </div>
              <h3 className="about-care-offer-card-title">{t('aboutCare.features.aiAssistant.title')}</h3>
              <p className="about-care-offer-card-desc">
                {t('aboutCare.features.aiAssistant.description')}
              </p>
            </div>
            {/* Card 3 */}
            <div className="about-care-offer-card" style={{ direction: i18n.dir() }}>
              <div
                className="about-care-offer-icon"
                style={{ background: "#19c37d" }}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="12" fill="#19c37d" />
                  <rect x="7" y="6" width="10" height="12" rx="2" fill="#fff" />
                  <path d="M9 10h6M9 12h6M9 14h4" stroke="#19c37d" strokeWidth="1.5" />
                  <circle cx="15" cy="9" r="2" stroke="#19c37d" strokeWidth="1.5" fill="#fff" />
                </svg>
              </div>
              <h3 className="about-care-offer-card-title">
                {t('aboutCare.features.liveSessions.title')}
              </h3>
              <p className="about-care-offer-card-desc">
                {t('aboutCare.features.liveSessions.description')}
              </p>
            </div>
          </div>
        </div>

        {/* User Benefits Section */}
        <div className="about-care-benefits-section">
          <h2 className="about-care-benefits-title">{t('aboutCare.benefits.title')}</h2>

          <div className="about-care-benefits-cards">
            {/* Pet Guardians */}
            <div className="about-care-benefit-card guardians" style={{ direction: i18n.dir() }}>
              <div className="about-care-benefit-icon" style={{ background: "#8548a8" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="#fff" strokeWidth="2" />
                  <circle cx="12" cy="7" r="4" stroke="#fff" strokeWidth="2" />
                  <path d="M12 14l2 2 4-4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3>{t('aboutCare.benefits.petGuardians.title')}</h3>
              <p>
                {t('aboutCare.benefits.petGuardians.description')}
              </p>
            </div>

            {/* Veterinarians */}
            <div className="about-care-benefit-card vets" style={{ direction: i18n.dir() }}>
              <div className="about-care-benefit-icon" style={{ background: "#2a8ad2" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="12" cy="8" r="3" stroke="#fff" strokeWidth="2" />
                </svg>
              </div>
              <h3>{t('aboutCare.benefits.veterinarians.title')}</h3>
              <p>
                {t('aboutCare.benefits.veterinarians.description')}
              </p>
            </div>

            {/* Service Providers */}
            <div className="about-care-benefit-card providers" style={{ direction: i18n.dir() }}>
              <div className="about-care-benefit-icon" style={{ background: "#ff9c5a" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#fff" strokeWidth="2" />
                  <circle cx="9" cy="7" r="4" stroke="#fff" strokeWidth="2" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="#fff" strokeWidth="2" />
                  <star cx="18" cy="8" r="2" stroke="#fff" strokeWidth="2" />
                </svg>
              </div>
              <h3>{t('aboutCare.benefits.serviceProviders.title')}</h3>
              <p>
                {t('aboutCare.benefits.serviceProviders.description')}
              </p>
            </div>
          </div>
        </div>

        {/* Closing Statement */}
        <div className="about-care-closing-section">
          <div className="about-care-closing-content">
            <h2 className="about-care-closing-title">{t('aboutCare.closing.title')}</h2>
            <h3 className="about-care-closing-subtitle">{t('aboutCare.closing.subtitle')}</h3>
            <p className="about-care-closing-desc">
              {t('aboutCare.closing.description')}
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AboutSulhafaCare;
